<template> 
  <HeaderComponent />
  <HomePage msg="Welcome to Your Vue.js App" style="overflow-y: scroll; height: 600px;"/>
  <FooterComponent />
</template>

<script>
import HomePage from './components/Home.vue'
import HeaderComponent from './components/Header.vue'
import FooterComponent from './components/Footer.vue'

export default {
  name: 'App',
  components: {
    HomePage,
    HeaderComponent,
    FooterComponent
  }
}
</script>
 